import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useGetSystemTime } from '../../hooks/server/server-time';

function Time({ date }: { date: string }): JSX.Element {
  const [currentTime, setCurrentTime] = useState(new Date(Date.parse(date)));

  useEffect(() => {
    const timerId = setInterval(() => {
      setCurrentTime(new Date(currentTime.getTime() + 1000));
    }, 1000);

    return () => clearInterval(timerId);
  }, [currentTime]);

  return <Box sx={{ fontSize: '13px', fontWeight: 500 }}>{currentTime.toLocaleTimeString()}</Box>;
}

function SystemTime(): JSX.Element {
  const { t } = useTranslation();

  const { isLoading, isError, data } = useGetSystemTime();

  return (
    <Box
      sx={{
        borderLeft: '1px solid #67bcff',
        pl: '20px',
        height: '40px',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      {!isLoading ? (
        <>
          {!isError && data ? (
            <Tooltip arrow title={t('server_time.tooltip')}>
              <Box sx={{ display: 'flex', alignItems: 'center', columnGap: '5px' }}>
                <AccessTimeIcon />
                <Time date={data.time} />
              </Box>
            </Tooltip>
          ) : (
            <Box sx={{ fontSize: '13px', fontWeight: 500 }}>{t('server_time.failed')}</Box>
          )}
        </>
      ) : (
        <Box sx={{ fontSize: '13px', fontWeight: 500 }}>{t('server_time.loading')}</Box>
      )}
    </Box>
  );
}

export default SystemTime;
